<style lang="scss">
$leftWidth: 220px;

.applyInForm {
  .content-part {
    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }

  .level-pic {
    margin-left: 100px;
    margin-right: 20px;
    margin-bottom: 16px;
    background: #eee;
    min-height: 160px;
    padding-top: 40px;
    position: relative;

    &-li {
      position: absolute;
      right: 0;
      bottom: 0;
    }

    &-title {
      line-height: 22px;
      padding-left: 12px;
    }
  }

  .level-table {
    margin-right: 20px;
    margin-left: 100px;

    .el-input__inner {
      height: 22px;
    }
  }
}
</style>
<template>
  <div class="applyInForm">
    <div class="content-part">
      <!--<div class="content-left">-->
      <!--<h2 class="clearfix right-title" style="font-size: 16px">上传追溯码</h2>-->
      <!--</div>-->
      <div class="content-right min-gutter">
        <h3>申请追溯码</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="100px" style="padding-right: 20px">
            <el-form-item label="子类编码" prop="productSubclassId">
              <el-select placeholder="请输入名称搜索子类编码" v-model="form.productSubclassId" filterable remote
                         :remote-method="platForm ? queryAllManageChildrenGoods : queryManageChildrenGoods"
                         @change="goodsChildrenChange"
                         :clearable="true" popperClass="custom-select"
                         @focus="platForm ? queryAllManageChildrenGoods('') : queryManageChildrenGoods('')"
                         @click.native.once="platForm ? queryAllManageChildrenGoods('') : queryManageChildrenGoods('')">
                <el-option :label="item.productSubclassCode" :value="item.productSubclassId"
                           :key="item.productSubclassId"
                           v-for="(item, index) in manageChildrenGoods">
                  <ManageChildrenGoodsOption :optionItem="item"/>
                </el-option>
                <el-option disabled value="-1" label="" v-if="manageChildrenGoods.length === 0">
                  <div style="text-align: center;">无货品子类和资源码，请维护</div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="0" v-if="form.productSubclassId && currentChildrenGoods">
              <oms-col label="子类编码" :value="currentChildrenGoods.productSubclassCode"/>
              <oms-col label="产品编码" :value="currentChildrenGoods.productCode"/>
              <!--              <oms-col label="规格" :value="currentChildrenGoods.productSpecification"/>-->
              <oms-col label="剂型" :value="currentChildrenGoods.productDosage">
                {{ currentChildrenGoods.productDosage }}
              </oms-col>
              <oms-col label="剂型规格" :value="currentChildrenGoods.productSpecification"/>
              <oms-col label="包装规格" :value="currentChildrenGoods.productPackingSpecification"/>
            </el-form-item>
            <el-form-item label="货品" prop="goodsId">
              <el-select placeholder="请输入名称搜索货品" v-model="form.goodsId" filterable remote
                         :remote-method="platForm ? queryAllManageGoods : queryManageGoods" @change="goodsChange"
                         :clearable="true" popperClass="custom-select"
                         :disabled="!form.productSubclassId"
                         @click.native="platForm ? queryAllManageGoods('') : queryManageGoods('')">
                <el-option :label="item.name" :value="item.goodsId" :key="item.id" v-for="item in manageGoods">
                  <manage-goods-option :optionItem="item"/>
                </el-option>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label-width="0" v-show="form.goodsId">-->
            <!--              <oms-col label="规格" :value="currentGoods.specifications"/>-->
            <!--              <oms-col label="追溯码商品编号" :value="currentGoods.goodsTrackNo" :is-show="true"/>-->
            <!--            </el-form-item>-->
            <el-form-item label="包装比例" prop="packageRatio">
              <el-select placeholder="请输入名称搜索包装比例" v-model="form.packageRatio" filterable remote
                         @change="packageRatioChange"
                         :disabled="!form.productSubclassId"
                         :clearable="true" popperClass="custom-select">
                <el-option :label="item.ratio" :value="item.ratio" :key="index"
                           @click.native="packageRatioChangeClick(item)"
                           v-for="(item, index) in packageRatioGroup" :disabled="!Boolean(item.ratio)">
                  <el-tooltip :disabled="Boolean(item.ratio)" class="item" effect="dark" content="无包装比例信息，请维护"
                              placement="left">
                    <div>
                      <div>
                        <span class="pull-left select-other-info">追溯码版本: {{ item.version }}</span>
                      </div>
                      <div class="clearfix">
                        <span class="pull-left select-other-info"
                        >包装比例: {{ item.ratio || '暂无' }}</span>
                      </div>
                    </div>
                  </el-tooltip>
                </el-option>
                <el-option disabled value="-1" label="" v-if="packageRatioGroup.length === 0">
                  <div style="text-align: center;">无资源码信息，请维护</div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="level-pic" :style="{height: (60 + (newTableData.length + 1) * 25) + 'px'}" v-if="newTableData">
            <div class="level-pic-li" :style="{
              zIndex: index,
              width: (60 + (newTableData.length - index + 1) * 25) + 'px',
              height: (60 + (newTableData.length - index + 1) * 25) + 'px',
              background: colorList[index]
            }" v-for="(item, index) in newTableData" :key="index">
              <div class="level-pic-title">
                {{ item.packingCount + item.packingUnit }}
              </div>
            </div>
          </div>

          <div class="level-table" v-if="newTableData">
            <el-table :data="newTableData" border>
              <el-table-column label="包装级别" prop="packingLevel">
              </el-table-column>
              <el-table-column label="每级件数" prop="packingCount">
              </el-table-column>
              <el-table-column label="所需追溯码">
                <template slot-scope="scope">
                  <el-input @input="handleCodeChange" v-if="scope.$index === 0" placeholder=""
                            v-model.trim.number="scope.row.tab4" type="number" :min="0"></el-input>
                  <span v-else>{{ scope.row.tab4 }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>


          <div style="margin-top: 16px; padding-left: 100px;">
            <el-button type="primary" :loading="doing" @click="handleCodeAdd">开始申请</el-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http, resourceCode, traceCode} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import ManageChildrenGoodsOption from '@/components/common/select/option-child-manage-goods.vue';

export default {
  components: {ManageChildrenGoodsOption},
  props: ['defaultIndex', 'platForm'],
  mixins: [methodsMixin],
  data() {
    return {
      packageRatioGroup: [],
      tabledatas: [],
      newTableData: [],
      form: {
        goodsId: '',
        batchNumberIdList: [],
        productSubclassId: '',
        packageRatio: '',
        childBatchNumberIdList: [],
        attachmentIdList: [],
        model: 0
      },
      rules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        productSubclassId: {required: true, message: '请选择子类编码', trigger: 'change'},
        packageRatio: {required: true, message: '请选择包装比例', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'}
      },
      doing: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: null
    };
  },
  computed: {
    colorList() {
      return this.$store.state.colorList;
    },
    currentGoods() {
      return this.manageGoods.filter(f => f.goodsId === this.form.goodsId)[0] || {};
    },
    currentChildrenGoods() {
      let newList = JSON.parse(JSON.stringify(this.manageChildrenGoods))
      return newList.find(f => f.productSubclassId === this.form.productSubclassId);
    },
    uploading() {
      return this.uploadingFiles && this.uploadingFiles.percentage < 100;
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
    },
    'form.productSubclassId'(val) {
      if (!val) {
        this.form.goodsId = '';
        return;
      }
      // 设置值
      this.form.goodsId = this.currentChildrenGoods.goodsId;
      this.queryManageGoodsByGoodsId(this.currentChildrenGoods.goodsId);
    }
  },
  methods: {
    handleCodeAdd() {
      this.$refs.form.validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        if (this.newTableData.length === 0 || this.newTableData[0].tab4 === 0) {
          return this.$notify.error({
            message: '追溯码申请数量不能为0'
          });
        }
        this.doing = true;
        let params = [];
        this.newTableData.map(m => {
          params.push({
            applyCount: m.tab4,
            level: m.packingLevel,
            resourceCodeId: m.resourceCodeId
          })
        })
        traceCode.addCode(this.form.productSubclassId, params).then(res => {
          if (res.data === 400) return;
          this.$notify.success({
            message: '申请成功'
          });
          this.tabledatas = [];
          this.newTableData = [];
          this.packageRatioGroup = [];
          this.$parent.close();
          this.$parent.$parent.getOrderList(1);
          this.doing = false;
        }).catch(e => {
          console.log(e)
          if (e && e.response && e.response.data && e.response.data.code && e.response.data.code === 400) {
            this.doing = false;
            return this.$notify.error({
              duration: 2000,
              message: e.response.data.data
            });
          }
          this.$notify.error({
            duration: 2000,
            message: this.$errHandler(e)
          });
          this.doing = false;
        })
      })
    },
    handleCodeChange(val) {
      if (!val) {
        this.newTableData.map((m) => {
          m.tab4 = 0;
        })
      } else {
        let firstCodesNum = parseFloat(val);
        this.newTableData.map((m, index) => {
          if (index !== 0) {
            let times = this.newTableData[0].packingCount;
            for (let i = 1; i <= index; i++) {
              times = times * this.newTableData[i].packingCount
            }
            this.newTableData[index].tab4 = firstCodesNum * times
          }
        })
      }
    },
    setIsUploading(val) {
      this.isUploading = val;
    },
    onUploadProgress(file) {
      this.setIsUploading(false);
      this.uploadingFiles = file;
    },
    changeFiles(files) {
      this.form.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = null;
    },
    queryGoodsBatchNumber(query) {
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')(query);
    },
    packageRatioChangeClick(val) {
      console.log(val);
      if (val.ratio) {
        this.newTableData = val.group;
      }
    },
    packageRatioChange(val) {
      console.log(val);
    },
    goodsChildrenChange(val) {
      this.form.packageRatio = '';
      if (!val) {
        this.tabledatas = [];
        this.newTableData = [];
        this.packageRatioGroup = [];
        return;
      }
      resourceCode.queryCode({productSubclassId: val}).then(res => {
        let newData = JSON.parse(JSON.stringify(res.data)).sort((a, b) => {
          return b.packingLevel - a.packingLevel
        });
        newData.map(m => {
          m.tab4 = 0
        });
        this.tabledatas = newData;
        //  根据住宿码版本以及包装比例分隔资源码信息
        let versionList = [];
        newData.map(m => {
          if (!versionList.find(f => f.version === m.codeVersion)) {
            versionList.push({version: m.codeVersion, ratio: []})
          }
        })
        versionList.map(m => {
          (newData.filter(f => {
            return f.codeVersion === m.version
          })).map(m2 => {
            if (!m.ratio.find(f => f === m2.packageRatio)) {
              m.ratio.push(m2.packageRatio)
            }
          })
        })
        let packageRatioGroup = []
        versionList.map((m, i) => {
          m.ratio.map((m2, i2) => {
            packageRatioGroup.push({
              version: m.version,
              ratio: m2,
              group: newData.filter(f => {
                return f.codeVersion === m.version && f.packageRatio === m2
              }).sort((a, b) => {
                return b.packingLevel - a.packingLevel
              })
            })
          })
        })
        this.packageRatioGroup = packageRatioGroup;
      })
    },
    goodsChange(val) {
      this.form.productSubclassId = '';
      this.form.packageRatio = '';
      this.tabledatas = [];
      this.newTableData = [];
      this.packageRatioGroup = [];
      this.manageChildrenGoods = [];
      this.form.batchNumberIdList = [];
      this.goodsBatchNumberList = [];
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')('');
    },
    resetForm() {
      this.form = {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        productSubclassId: '',
        packageRatio: '',
        model: 0
      };
      this.tabledatas = [];
      this.newTableData = [];
      this.packageRatioGroup = [];
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = null;
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        if (!this.currentGoods.goodsTrackNo) {
          return this.$notify.info({
            message: '追溯码商品编号为空，请联系管理员'
          });
        }
        if (!this.form.attachmentIdList.length) {
          this.$notify.info({
            message: '请选择追溯码文件'
          });
          return;
        }
        // if (!this.isUploading) {
        //   this.$notify.info({
        //     message: '追溯码文件还没有上传完成，请等待'
        //   });
        //   return;
        // }
        this.form.type = 1;
        this.form.model = this.isChecked ? 1 : 0;
        this.doing = true;
        http.post('/code/org/parse/trace-code', this.form).then(res => {
          this.$emit('refresh', {id: res.data});
          this.resetForm();
          this.doing = false;
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '解析失败'
          });
          this.doing = false;
        });
      });
    }
  }
};
</script>
